export default "__VITE_ASSET__BQoV3BQd__"